import { Injectable } from '@angular/core';
import { BaseDataService } from '../../../../core/service/base-data.service';
import {
  Team,
  TeamGroupedList,
  TeamHierarchy,
  TeamPaginated,
  UserTeamHierarchy,
} from '../models/team.model';
import { Observable } from 'rxjs';
import { BaseFilterVm } from '../../../../shared/models/filter-data.model';

@Injectable({
  providedIn: 'root',
})
export class TeamService {
  private apiTeamUrl = 'api/Team';

  constructor(private baseDataService: BaseDataService) {}

  createTeam(team: Team): Observable<boolean> {
    return this.baseDataService.makePostCall(`${this.apiTeamUrl}`, team);
  }

  getAllTeams(
    filter: BaseFilterVm
  ): Observable<TeamPaginated | TeamGroupedList[]> {
    return this.baseDataService.makePostCall(
      `${this.apiTeamUrl}/getAllTeams`,
      filter
    );
  }

  deleteTeam(teamId: string): Observable<any> {
    return this.baseDataService.makeDeleteCall(`${this.apiTeamUrl}/${teamId}`);
  }

  getTeamById(id: string): Observable<Team> {
    return this.baseDataService.makeGetCall(`${this.apiTeamUrl}/${id}`);
  }

  editTeam(team: Team): Observable<any> {
    return this.baseDataService.makePutCall(`${this.apiTeamUrl}`, team);
  }

  getTeamHierarchicalResponse(userId?: string): Observable<TeamHierarchy[]> {
    let query = userId ? '?userInformationId=' + userId : '';

    return this.baseDataService.makeGetCall(
      `${this.apiTeamUrl}/getTeamHierarchicalResponse${query}`
    );
  }

  getUserTeamHierarchicalResponse(
    userId?: string,
    isPrivilegedUser?: boolean
  ): Observable<UserTeamHierarchy> {
    return this.baseDataService.makeGetCall(
      `${this.apiTeamUrl}/getUserTeamHierarchicalResponse?userInformationId=${userId}&isPrivilegedUser=${isPrivilegedUser}`
    );
  }
}
